import React from 'react'
import { SearchPanelFilterPill } from '@Components/Search/SearchPanel/types'
import './index.scss'

interface FilterPillProps {
    filterPill: SearchPanelFilterPill
}

const FilterPill = ({ filterPill }: FilterPillProps) => {
    const [filterType, ...filterValueParts] = filterPill.label.split(':')
    const filterValue = filterValueParts.join(':').trim()
    return (
        <span className="filter-pill">
            <span className="filter-pill-text">
                <span className="filter-pill-type">{filterType}:</span>
                <span className="filter-pill-value">{filterValue}</span>
            </span>
            {filterPill.onRemove && (
                <button
                    type="button"
                    className="filter-pill-remove"
                    onClick={filterPill.onRemove}
                    aria-label={`Remove filter ${filterPill.label}`}
                >
                    ×
                </button>
            )}
        </span>
    )
}

export default FilterPill
